<div>
	<app-create-employee-side-form
		[label]="employee ? 'Edit record' : 'Add a new record'"
		[minify]="false"
		[checkboxLabel]="checkboxLabel"
		[employee]="employee"
		[company]="company"
		(onSubmit)="onCreate($event)"
		(onCancel)="onCancel()"
	>
	</app-create-employee-side-form>
</div>
